import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const useIsSearchDebug = () => {
    const router = useRouter();
    const [isSearchDebug, setIsSearchDebug] = useState(router.query.debug === 'true');
    useEffect(() => {
        setIsSearchDebug(router.query.debug === 'true');
    }, [router]);
    return isSearchDebug;
};
